import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['No tenés un protocolo claro para patologías frecuentes y complejas', 'Perdés tiempo buscando información dispersa en papers y guías', 'Te sentís inseguro/a al interpretar estudios de laboratorio', 'Te trabás cuando el paciente clínico no evoluciona como esperabas', 'Adaptar un plan para múltiples patologías te lleva demasiado tiempo', 'El seguimiento clínico se vuelve improvisación en lugar de un proceso estructurado', 'Sabés que podrías cobrar mejor, pero te falta un abordaje clínico más sólido y profesional'];
  return <section className="pt-4 pb-5" data-id="element-189">
      <div className="max-w-3xl mx-auto px-3" data-id="element-190">
        <FadeIn data-id="element-191">
          <h2 className="font-display text-2xl md:text-3xl font-bold mb-3 text-center text-accent" data-id="element-192">
            Si sos nutricionista clínico, esto te va a sonar familiar:
          </h2>
        </FadeIn>

        <div className="space-y-2 mb-2" data-id="element-193">
          {points.map((point, idx) => <FadeIn key={idx} delay={idx * 0.1} className="flex items-start gap-2.5 !p-2.5 rounded-lg border-red-500/20" data-id="element-194">
              <XCircle className="text-red-400 shrink-0 mt-0.5" size={18} data-id="element-195" />
              <p className="text-sm md:text-base font-medium text-white" data-id="element-196">
                {point}
              </p>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-197">
          <p className="text-center text-lg md:text-xl italic max-w-2xl mx-auto font-[900] font-['Open_Sans',_sans-serif] text-[#C9A96E]" data-id="element-198">
            ¿Cuántas veces más vas a salir de consulta sintiendo que podrías
            haber dado más?
          </p>
        </FadeIn>
      </div>
    </section>;
}